import Vue from 'vue'
import Route from 'vue-router'

Vue.use(Route)

const routes = [
  {
    path: '/home'
  },
  {
    path: '/register'
  },
  {
    path: '/lostPassword'
  },
  {
    path: '/modifyPassword'
  },
  {
    path: '/shine'
  },
  {
    path: '/epi-clock'
  },
  {
    path: '/wind'
  },
  {
    path: '/about'
  },
  {
    path: '/feedback'
  }
]

const router = new Route({
  linkActiveClass: 'active',
  hashbang: true,
  history: true,
  routes
})

router.beforeEach((to, from, next) => {
  if (routes.some(e => e.path === to.path)) {
    next()
  } else {
    next({path: '/home'})
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js